import { createFileRoute } from "@tanstack/react-router";

import { OnboardingJobsPage } from "@/pages/Sales";

export const Route = createFileRoute("/app/admin/investor-onboarding-jobs/")({
  component: AdminOnboardingJobsRoute,
});

function AdminOnboardingJobsRoute() {
  return <OnboardingJobsPage variant="admin" />;
}
